'use strict';

// import Swiper bundle with all modules installed
import Swiper from 'swiper';
import {A11y, Autoplay, EffectFade, Keyboard, Navigation, Pagination} from 'swiper/modules';

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

//import "accordionjs/accordion.min";

function J3WTheme() {

    var self = this;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#js-header");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#js-main-menu");
    self.$mainNav = $("#main-nav");
    self.$mobileMenu = $("#js-mobile-menu");

    self.init();
}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        self.onBind();
        //self.cloneMainMenu();
        //self.fancybox();
        //self.accordion();
        self.swiperHeroInit();
        self.heroAutoplayToggle();
        //self.carouselInit();
        self.wrapTables();

    },

    // Viditelny ovladac pro zastaveni automatickeho prehravani hero slideru (WCAG 2.2.2).
    // Tlacitko vklada JS, aby se bez funkcniho slideru vubec neobjevilo.
    heroAutoplayToggle: function () {

        var self = this;
        var swiper = self.swiperHero;

        if (!swiper || !swiper.autoplay || !swiper.el) {
            return;
        }

        // Pri omezenem pohybu autoplay vubec nebezi, neni co zastavovat
        if (prefersReducedMotion()) {
            return;
        }

        var labelPause = "Pozastavit prezentaci";
        var labelPlay = "Spustit prezentaci";

        var $button = $('<button type="button" class="hero__autoplay js-hero-autoplay">' +
            '<span class="visually-hidden">' + labelPause + '</span></button>');

        $(swiper.el).append($button);

        // Stav rozhoduje jen podle autoplay.running. autoplay.paused je docasne
        // zastaveni pri najeti mysi (pauseOnMouseEnter) - a protoze tlacitko lezi
        // uvnitr slideru, pri kliknuti mysi je paused vzdy true.
        function syncButton() {
            var isRunning = swiper.autoplay.running;

            $button.toggleClass("hero__autoplay--paused", !isRunning)
                .find(".visually-hidden").text(isRunning ? labelPause : labelPlay);
        }

        $button.on("click", function () {
            if (swiper.autoplay.running) {
                swiper.autoplay.stop();
            }
            else {
                swiper.autoplay.start();

                // Po zastaveni zustava paused === true, dokud kurzor neopusti slider.
                // Bez resume() se odpocet nerozebehne, prestoze running uz je true.
                if (swiper.autoplay.paused) {
                    swiper.autoplay.resume();
                }
            }

            syncButton();
        });

        // disableOnInteraction zastavi autoplay i pri kliknuti na sipky nebo swipu;
        // bez techto udalosti by tlacitko ukazovalo opacny stav, nez jaky plati
        swiper.on("autoplayStart", syncButton);
        swiper.on("autoplayStop", syncButton);

        syncButton();

    },

    // Tabulky v obsahu obalíme posuvným kontejnerem,
    // aby při přetečení doprava získaly vodorovný scrollbar.
    // Scrollovatelná oblast musí jít ovládat z klávesnice, proto tabindex + role (WCAG 2.1.1)
    wrapTables: function () {

        $(".the-content table, .page__content table").each(function () {
            var $table = $(this);

            if ($table.parent().hasClass("table-responsive")) {
                return;
            }

            $table.wrap('<div class="table-responsive" tabindex="0" role="region" aria-label="Tabulka, posuvná vodorovně"></div>');
        });

    },

    onBind: function () {

        var self = this;

        self.$window.on('scroll', function () {
            self.bodyScrollClass(self);
        });

        self.$hamburger.on("click", function () {
            self.mobileMenu();
        });

        $("#js-open-search").on("click", function(){
            var isOpen = $("#js-searchbar").toggleClass("searchbar--open").hasClass("searchbar--open");

            // Ikona se meni na krizek a tlacitko pak panel zavira - nazev to musi rict taky,
            // samotne aria-expanded popisuje stav, ne akci. (WCAG 2.4.6)
            $(this).attr("aria-expanded", isOpen ? "true" : "false")
                .find(".visually-hidden").text(isOpen ? self.labelSearchClose : self.labelSearchOpen);

            if (isOpen) {
                setTimeout(function() {
                    $("#js-search-text").focus();
                }, 300 );
            }
        });

        $("#js-searchbar-bg").on("click", function(){
            self.closeSearch();
        });

        self.$document.keydown(function (e) {
            var $searchbar = $("#js-searchbar");

            if (e.cancelable === true && e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27) {
                if ($searchbar.hasClass("searchbar--open")) {
                    self.closeSearch();
                    $("#js-open-search").focus();
                }
                if (self.$mobileMenu.hasClass("mobile-menu--open")) {
                    self.mobileMenu();
                }
            }

            // Jen jeden z obou muze byt otevreny, menu ma prednost.
            if (self.$mobileMenu.hasClass("mobile-menu--open")) {
                self.trapFocus(e, self.$mobileMenu);
            }
            else if ($searchbar.hasClass("searchbar--open")) {
                self.trapFocus(e, $searchbar);
            }
        });

        $(".more-info-btn").on("click", function(e) {
            $("#more-info").toggleClass("open");
            $(this).toggleClass("btn-icon--arr-expand btn-icon--arr-expand-less");
            e.preventDefault();
        });

        $(".js-mobile-submenu-open").on( "click", function() {
            var isOpen = $(this).toggleClass("_opened").hasClass("_opened");

            $(this).attr("aria-expanded", isOpen ? "true" : "false")
                .closest("li").find("> ul").slideToggle( 300 );
        } );

    },

    labelSearchOpen: "Hledat",

    labelSearchClose: "Zavřít hledání",

    closeSearch: function () {

        var self = this;
        var $searchbar = $("#js-searchbar");
        var $button = $("#js-open-search");

        if (!$searchbar.length) {
            return;
        }

        // Fokus nesmi zustat na skrytem prvku uvnitr panelu - vracime ho na tlacitko,
        // ktere panel otevrelo. (WCAG 2.4.3)
        var focusInside = $.contains($searchbar[0], document.activeElement);

        $searchbar.removeClass("searchbar--open");
        $button.attr("aria-expanded", "false")
            .find(".visually-hidden").text(self.labelSearchOpen);

        if (focusInside) {
            $button.focus();
        }

    },

    // Prvky dosazitelne tabulatorem. Skryte vetve podmenu odfiltruje :visible.
    focusableSelector: 'a[href], button:not([disabled]), input:not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',

    // Pri otevrenem menu nebo vyhledavani nesmi tabulator odejit do stranky pod nimi.
    // Tlacitko, ktere panel zavira, lezi uvnitr obou kontejneru, takze cesta ven zustava.
    // (WCAG 2.4.3)
    trapFocus: function (e, $container) {

        var self = this;

        if (e.key !== 'Tab' && e.keyCode !== 9) {
            return;
        }

        var $items = $container.find(self.focusableSelector).filter(':visible');

        if (!$items.length) {
            return;
        }

        var first = $items.first()[0];
        var last = $items.last()[0];

        if (!$.contains($container[0], document.activeElement)) {
            first.focus();
            e.preventDefault();
        }
        else if (e.shiftKey && document.activeElement === first) {
            last.focus();
            e.preventDefault();
        }
        else if (!e.shiftKey && document.activeElement === last) {
            first.focus();
            e.preventDefault();
        }

    },

    accordion: function(){

        $(".accordion").accordionjs({
            // Allow self close.(data-close-able)
            closeAble   : true,
            // Close other sections.(data-close-other)
            closeOther  : false,
            // Animation Speed.(data-slide-speed)
            slideSpeed  : 300,
            // The section open on first init. A number from 1 to X or false.(data-active-index)
            activeIndex : false,
            // Callback when a section is open
            //openSection: function( section ){},
            // Callback before a section is open
            //beforeOpenSection: function( section ){},
        });

        // Otevirame podle hashe v URL adrese
        var hash = new URL(document.URL).hash;

        if ( hash && $(".accordionjs").length > 0 ) {
            $(hash).addClass( "acc_active" ).find(".acc_content").show();
            $("html, body").animate({
                scrollTop: $(hash).offset().top - 100 // offset
            }, 150);
        }

    },

    mobileMenu: function(){

        var self = this, t;

        clearTimeout( t );

        //self.$body.toggleClass("mobile-menu-is-open");

        var $hamburger = $(".hamburger");

        if( self.$mobileMenu.hasClass("mobile-menu--open") ){
            self.$mobileMenu.removeClass("mobile-menu--open");
            $hamburger.attr("aria-expanded", "false");
            $(".header__hamburger").focus();
            t = setTimeout( function(){
                $hamburger.removeClass("is-active");
            }, 200 );
        }
        else {
            self.$mobileMenu.addClass("mobile-menu--open");
            $hamburger.attr("aria-expanded", "true");
            t = setTimeout( function(){
                $hamburger.addClass("is-active");
                self.$mobileMenu.find(".mobile-menu__hamburger").focus();
            }, 200 );
        }

    },

    cloneMainMenu: function(){

        $("#js-main-menu:not(.cloned)").addClass("cloned")
            .clone( true, true )
            .removeAttr("id")
            .appendTo("#js-sticky-menu-container");

    },

    bodyScrollClass: function ( self ) {

        //if( self.$document.scrollTop() > self.$header.outerHeight() ) {
        if( self.$document.scrollTop() > 0 ) {
            self.$body.addClass('js-scrolling');
        }
        else {
            self.$body.removeClass('js-scrolling');
        }
/*
        // potrebujeme vedet, jestli se scrolluje dolu nebo nahoru
        if ( ( document.body.getBoundingClientRect() ).top > self.scrollPos ) {
            self.$body.addClass('scroll-up');
        } else {
            self.$body.removeClass('scroll-up');
        }

        self.scrollPos = ( document.body.getBoundingClientRect() ).top;

        if( self.$document.scrollTop() < self.$header.outerHeight() + 100 ) {
            self.$body.addClass('hide-menu');
        } else {
            self.$body.removeClass('hide-menu');
        }
*/
    },

    fancybox: function() {

        $('[data-fancybox="gallery"]').fancybox({
            loop: true,
            buttons: [
                "zoom",
                "share",
                "slideShow",
                "fullScreen",
                //"download",
                //"thumbs",
                "close"
            ]
        });
    },

    swiperHeroInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-swiper-hero', {
            modules: [
                A11y,
                Autoplay,
                EffectFade,
                Navigation,
                Pagination,
                Keyboard
            ],
            loop: true,
            speed: 900,
            // Bez A11y modulu jsou sipky <div> bez role a bez tab stopu
            a11y: {
                enabled: true,
                prevSlideMessage: 'Předchozí snímek',
                nextSlideMessage: 'Další snímek',
                firstSlideMessage: 'První snímek',
                lastSlideMessage: 'Poslední snímek',
                paginationBulletMessage: 'Přejít na snímek {{index}}',
                slideLabelMessage: 'Snímek {{index}} z {{slidesLength}}',
                containerMessage: 'Úvodní prezentace'
            },
            // Automaticke prehravani se vypina, kdyz uzivatel omezil pohyb v systemu
            autoplay: prefersReducedMotion() ? false : {
                delay: 5000,
                disableOnInteraction: true,
                pauseOnMouseEnter: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: true,
            //lazyLoading: true,
            //lazy: {
            //    loadPrevNext: true,
            //},
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            /*
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }
            */
        });
    },

    carouselInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-carousel', {
            loop: true,
            speed: 900,
            autoplay: {
                delay: 2000,
                disableOnInteraction: true
            },
            //effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            navigation: {
                nextEl: '.carousel-nav--next',
                prevEl: '.carousel-nav--prev'
            },
            on: {
                transitionEnd: function() {
                    // vanilla lazyload
                    lazyLoadInstance.update();
                }
            },
            /*
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }*/
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                // when window width is >= 420px
                420: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            }
        });
    }
};

$(document).ready(function () {
    new J3WTheme();
});

// Tohle tady mame kvuli fancyboxu
// Kdyz to tu neni, fancybox hlasi chybu
// Netusim proc (novy fancybox by to vyresil, ale je placenej)
window.jQuery = window.$ = $;
